import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, BookOpen, Book, Target, Clock, CheckCircle2, ChevronRight } from 'lucide-react';

// Importa os estilos específicos deste cartão
import './aulaLista.css';

export default function FichaAula({ licao, data, situacao, presentes = 0, revista = 0, biblia = 0, aproveitamento = 0, id }){
    console.log(aproveitamento)
    // if(aproveitamento.length >= 0){
    //     aproveitamento = 0
    // }
    const navigate = useNavigate();
    
    // Tratamento de segurança caso a data venha vazia ou indefinida
    const dataModificada = data ? String(data).split("-").reverse().join("/") : "Sem data";
    
    // Verificação de status para aplicar as classes corretas
    const isAberta = situacao?.toLowerCase() === "aberta";

    return (
        <div 
            className={`card-aula ${isAberta ? 'card-aberta' : 'card-fechada'}`}
            onClick={() => navigate(`/aula/${id}`)}
        >
            {/* Topo do Card: Badge de Situação e Data */}
            <div className="card-topo">
                <div className={`status-badge ${isAberta ? 'badge-aberta' : 'badge-fechada'}`}>
                    {isAberta ? <Clock size={14} strokeWidth={2.5} /> : <CheckCircle2 size={14} strokeWidth={2.5} />}
                    {situacao}
                </div>
                <span className="aula-data">{dataModificada}</span>
            </div>

            {/* Título da Lição e Indicador de Clique */}
            <h3 className="aula-titulo">
                {licao}
                <ChevronRight size={20} color="#cbd5e1" className="seta-navegacao" />
            </h3>

            {/* Grid de Estatísticas Moderno */}
            <div className="stats-container">
                <div className="stat-item" title="Presentes">
                    <span className="stat-valor">
                        <Users size={16} className="stat-icon" /> {presentes}
                    </span>
                    <span className="stat-label">Pres.</span>
                </div>
                
                <div className="stat-item" title="Revistas">
                    <span className="stat-valor">
                        <BookOpen size={16} className="stat-icon" /> {revista}
                    </span>
                    <span className="stat-label">Rev.</span>
                </div>
                
                <div className="stat-item" title="Bíblias">
                    <span className="stat-valor">
                        <Book size={16} className="stat-icon" /> {biblia}
                    </span>
                    <span className="stat-label">Bíb.</span>
                </div>

                <div className="stat-item stat-destaque" title="Aproveitamento">
                    <span className="stat-valor">
                        <Target size={16} className="stat-icon" /> {aproveitamento}%
                    </span>
                    <span className="stat-label">Aprov.</span>
                </div>
            </div>
        </div>
    );
};


export const FichaTurmasAulas = ({nomeTurma, situacao,id})=>{
    const navigate = useNavigate()

    const isAberta = situacao?.toLowerCase() === "aberta";

    return(
        <div 
            className={`card-turma-aula ${isAberta ? 'card-aberta' : 'card-fechada'}`}
            onClick={()=>{
                navigate(`/aulachamada/${id}`)
            }}
        >
           
            <p>{nomeTurma}</p> 
            <div className="card-topo">
                <div className={`status-badge ${isAberta ? 'badge-aberta' : 'badge-fechada'}`}>
                    {isAberta ? <Clock size={14} strokeWidth={2.5} /> : <CheckCircle2 size={14} strokeWidth={2.5} />}
                    {situacao}
                </div>
            </div>
        </div>
    )
}